import {useIntl} from 'react-intl';
import {useEffect} from 'react';
import {Tooltip} from 'react-tippy';
import {ReactComponent as TooltipIcon} from 'assets/icons/tooltip.svg';
import {formDataLayerHelper} from 'utils/dataLayerHelper';

const Checkboxes = ({settings, onChange, setState}) => {
  const intl = useIntl();
  const {
    name,
    state,
    options,
    wrapperClasses,
    label,
    isTranslated = true,
    makeAllClickable = false,
    labelTooltip,
  } = settings || {};
  const dataLayerCallback = formDataLayerHelper(intl, settings);

  useEffect(() => {
    options.forEach((option) => {
      if (option.checked) {
        setState((prev) => {
          return {
            ...prev,
            [name]: [...prev[name] || [], option.value]
          }
        });
      }
    });
  }, []);

  if (!name || !options) {
    return '';
  }

  const preventTooltipClick = (event) => {
    const {tagName} = event.target;
    const prevent = ['div', 'path', 'svg'];
    if (prevent.includes(tagName.toLowerCase())) {
      event.preventDefault();
    }
  };

  const renderCheckboxes = () => {
    return options.map((option) => {
      const {label: optionLabel, value, disabled = false, tooltip} = option;
      const isChecked = state[name] && state[name].includes(value);

      return (
        <div
          className={`form-item form-item--checkbox ${isChecked ? 'form-item--checkbox-active' : ''} ${disabled ? 'form-disabled' : ''}`}
          key={`option-${value}`}>
          <input className="form-checkbox"
                 name={`${name}-${value.replaceAll(' ', '-')}`}
                 id={`${name}-${value.replaceAll(' ', '-')}`}
                 type="checkbox"
                 checked={isChecked}
                 value={value}
                 onChange={(event) => {
                   onChange(event);
                   if (typeof dataLayerCallback === 'function') {
                     dataLayerCallback(event);
                   }
                 }}
                 data-field-name={name}
                 disabled={disabled}
          />
          <label className="option" htmlFor={`${name}-${value.replaceAll(' ', '-')}`} onClick={preventTooltipClick}>
            {isTranslated ? intl.formatMessage({id: optionLabel}) : optionLabel}

            {tooltip && typeof tooltip === 'string' && tooltip.trim() !== '' ? (
              <Tooltip title={tooltip}
                       className="ml-5"
                       trigger="mouseenter focus click"
                       arrow={true}
                       tabIndex={0}
                       inertia={true}
                       interactive={true}>
                <div style={{display: 'inline-block', verticalAlign: 'sub', paddingBottom: '2px'}}>
                  <TooltipIcon/>
                </div>
              </Tooltip>
            ) : null}

            {makeAllClickable ? <span className="make-entire-card-clickable"></span> : ''}
          </label>

        </div>
      );
    });
  };

  const renderLabel = () => {
    if (!label) {
      return '';
    }

    return (
      <>
        <label className="checkboxes-label">
          {intl.formatMessage({id: label})}
          {labelTooltip ?
            <Tooltip title={intl.formatMessage({id: labelTooltip})}
                     className="ml-10"
                     trigger="mouseenter focus click"
                     arrow={true}
                     tabIndex={0}
                     inertia={true}
                     interactive={true}
                     style={{display: 'inline-block'}}>
              <TooltipIcon/>
            </Tooltip> : ''
          }
        </label>
      </>
    );
  };

  return (
    <div className={wrapperClasses}>
      {renderLabel()}
      {renderCheckboxes()}
    </div>
  );
};

export default Checkboxes;
